// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Y9XB_","dragIcon":"SortableItem_dragIcon__1NOx5","disabled":"SortableItem_disabled__2X_QC"};